import React from 'react';
import { Show } from '@bd-uikit-web/React/Utils';
import bdAuth from '@bd-uikit-web/js-helpers/bdAuth';
import bdReq from '@bd-uikit-web/js-helpers/bdReq';
import rootDispatcher from '@bd-uikit-web/js-helpers/rootDispatcher';
import StripeCheckout from '../components/StripeCheckout';

export default class PurchaseSubscription extends React.Component {
  constructor(props) {
    super();
    this.props = props;
    const endDate = new Date();
    endDate.setMonth(endDate.getMonth() + 1);

    this.state = {
      sending: false,
      user: null,
      plan: {},
      showCheckoutModal: false,
      activeSubscription: null,
      trial_end: this.formatDateToString(endDate),
    };
  }

  componentWillMount() {
    if (!bdAuth.isAuthenticated()) {
      rootDispatcher.dispatch('PURCHASESUBSCRIPTIONS');
      this.props.history.push('/');
      return;
    }

    // Get active subscription
    // getUser is synchronous now
    const user = bdAuth.getUser();
    if (user === null) {
      this.setState({
        sending: false,
      });
      return;
    }

    this.setState({
      user,
    });

    this.getSubscriptions(`/users/${user.id}/subscriptions`);


    this.getPlans(`/plans/${this.props.match.params.plan}`);

    this.setStateSending();

    this.onToken = (token) => {
      const apiLinkSubPlans = `/users/${user.id}/subscriptions/${this.state.plan.id}`;
      const apiData = { id: token.id, email: token.email };
      this.postStripeToken(apiLinkSubPlans, apiData);
    };
  }

  // @todo move this to a static global place.
  setStateSending() {
    this.setState({
      sending: true,
    });
  }

  getSubscriptions(apiLinkSubscriptions) {
    bdReq.get(apiLinkSubscriptions)
      .then(({ success, body }) => {
        if (success && body.length > 0) {
          this.setState({
            activeSubscription: body,
            sending: false,
          });
        }
      });
  }

  getPlans(apiLinkPlans) {
    bdReq.get(apiLinkPlans)
      .then(({ success, body }) => {
        if (!success) {
          this.setState({
            sending: false,
          });

          rootDispatcher.dispatch('NB:OPEN', {
            type: 'error',
            msg: body.message,
          });
          return;
        }

        this.setState({
          sending: false,
          plan: body,
        });
      });
  }

  // @todo move this to a static global place.
  formatDateToString(date) {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
      'August', 'September', 'October', 'November', 'December'];
    const dd = date.getDate();
    const MM = months[date.getMonth()];
    const yyyy = date.getFullYear();
    return (`${MM} ${dd}, ${yyyy}`); // Note this format is different than the other function.
  }

  postStripeToken(apiLinkSubPlans, apiData) {
    bdReq.post(apiLinkSubPlans, apiData)
      .then(({ success, body }) => {
        if (!success) {
          this.setState({
            sending: false,
          });

          rootDispatcher.dispatch('NB:OPEN', {
            type: 'error',
            msg: body.message,
          });
          return;
        }

        this.setState({
          sending: false,
          done: true,
        });

        this.props.history.push('/thank-you');
      });
  }

  render() {
    return (
      <div>
        <section className="row">
          <div className="col-12 pull-left">
            <p>
              <a href="/subscriptions" className="a--subdued">
                Subscription Overview
              </a>
              <span className="ion-chevron-right span--spacing"></span>
              Purchase Subscription
            </p>
          </div>
        </section>

        <Show className="container"
          condition={ !this.state.activeSubscription && this.state.plan !== {} }
        >
          <section className="row">
            <div className="col-12 text-center">
              <h4 className=
                "h--medium-weight h--lower h--spacing-both-xl">Purchase Subscription
              </h4>
            </div>
          </section>

          <section className="row">
            <div className="col-12">
              <section className="row">
                <div className="col-4 col-sm-full">
                  <div className={'plan-card plan-card--purchase'}>
                    <div className="plan-card__label"></div>
                    <header className="plan-card__header">
                      <h5 className="h--lower h--spacing-sm h--medium-weight">
                        { this.state.plan.name }
                      </h5>
                      <h1 className="plan-card__price" data-currency="$" data-period="/month">
                        { this.state.plan._embedded ?
                          this.state.plan._embedded.pricing.price
                          : ''
                        }
                      </h1>
                      <p>30 days free trail</p>
                    </header>
                    <ul className="current-plan-card__features current-plan-card__features-left">
                      {this.state.plan.benefits ?
                        this.state.plan.benefits.map((benefit, j) => (
                          <li key={j}>
                            <span className="checkmark-green ion-checkmark" />
                            { benefit.description }
                          </li>
                        ))
                        : ''
                      }
                    </ul>
                    <footer className="plan-card__footer">
                    </footer>
                  </div>
                </div>

                <div className="col-8 col-sm-full">
                  <div className="card">
                    <h4 className="h--lower h--spacing-sm h--medium-weight">
                      { this.state.plan.name } subscription
                    </h4>
                    <p>
                      You agree that you will get instant access to your curated subscription,
                      and that if you do not cancel before the trial
                      ends on { this.state.trial_end },
                      you will automatically be charged
                      the subscription fee every month until you cancel.
                      In the event of termination, you are not entitled to a refund.
                    </p>

                    <h5 className="h--lower h--regular-weight h--spacing-sm">Breakdown:</h5>

                    <ul className="current-plan-card__features">
                      <li>
                        <div className="pull-left">
                          Curated subscription
                        </div>

                        <div className="pull-right">
                          ${ this.state.plan._embedded ?
                            this.state.plan._embedded.pricing.price
                            : ''
                          } / month
                        </div>

                        <div className="clear"></div>
                      </li>
                    </ul>

                    <h5 className="h--lower h--regular-weight h--spacing-sm pull-left">
                      Total
                    </h5>
                    <h5 className="h--lower h--regular-weight h--spacing-sm pull-right">
                      ${ this.state.plan._embedded ?
                        this.state.plan._embedded.pricing.price
                        : ''
                      } / month
                    </h5>

                    <div className="clear"></div>

                    <br />
                    <button type="submit"
                      className="button-no-float btn--dark btn--text-lower pull-left"
                      onClick={() => this.setState({showCheckoutModal: true})}
                    >
                      Purchase
                    </button>
                    <StripeCheckout
                      open={this.state.showCheckoutModal}
                      amount=
                        { this.state.plan._embedded ?
                          this.state.plan._embedded.pricing.price
                          : 0
                        }
                      currency="USD"
                      email={bdAuth.getUser().email}
                      onToken={this.onToken}
                    />
                    <div className="clear"></div>
                  </div>
                </div>
              </section>
            </div>
          </section>
        </Show>
      </div>
    );
  }
}

